import { Logger } from '@lettheinsideout/logger';

export const log = new Logger();
